import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
//import { actionCreators } from '../store/WeatherForecasts';
import { actionCreators } from '../store/actions/dataActions';
// Import React Table
import ReactTable from "react-table";
import "react-table/react-table.css";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Shortlist from './shortlist';
import ListShortlists from './ListShortLists';
import ShortListFromISRC from './ShortListFromISRC';
import "react-table/react-table.css";
import Select from 'react-select';
import ReadyShortlist from './ReadyShortlists';
import { CSVLink } from 'react-csv';


class Release extends Component {

    constructor(props) {
        super(props);
        this.state = {
            upcs: "",
            isrcs:""
        };
     
    }
componentDidMount() {
    // This method is called when the component is first added to the document
   
    this.ensureDataFetched();
   
}

componentDidUpdate() {
    // This method is called when the route parameters change
    //this.ensureDataFetched();
}

ensureDataFetched() {
    const startDateIndex = parseInt(this.props.match.params.startDateIndex, 10) || 0;
    // this.props.requestWeatherForecasts(startDateIndex);
   // this.props.getData();
 
    }


    onUPCChange(e) {
        this.setState({ upcs: e.target.value });
    }

    onISRCChange(e) {
        this.setState({ isrcs: e.target.value });
    } 

render() {
    const access = localStorage.getItem("accessToken");
    console.info(this.props.upcData);
    let url = this.props ? this.props.audioURL : '';
    return (
        <div>              
                <h1>Release State</h1>

                <div className="row">
                <div className="col-sm-9">
                    <input type="text" disabled={this.props.isLoadingReleaseList} className="form-control" id="shortlistISRC" placeholder={"UPCS"} onChange={(e) => this.onUPCChange(e)} value={this.state.upcs} ></input>
                </div>
                <div className="col-sm-3">

                    <button disabled={this.state.upcs === '' || this.props.isLoadingReleaseList} onClick={(e) => this.props.getReleaseData(this.state.upcs)}>Search</button></div>
            </div>

            <br />

          
            <br/>
                <div className="row">
                <div className="col-sm-12">
                    {this.props.releaseData !== null && this.props.releaseData.length > 0 ? <CSVLink data={this.props.releaseData} filename="Release-Data.csv" >Download CSV</CSVLink> : ""}
                    {this.props.releaseData != null ? renderReactTable(this.props.releaseData, this.props, this) : ""}
                    </div>
                </div>

            </div>
          
     
            
            
          

        
    );
}
}



function renderReactTable(data, props,main) {

    console.info(main.state.filtered);

    const getColumns = () => {
        return Object.keys(data[0]).map(key => {
            return {
                Header: key,
                accessor: key
            };
        });
    }
    const onRowClick = (state, rowInfo, column, instance) => {
        if (typeof rowInfo !== "undefined") {
            return {
              
                style: {
                    background: props.tempShortList && props.tempShortList.filter(t => t.isrc === rowInfo.original.isrc).length > 0 ? '#00afec' : 'white',
                    color: props.tempShortList && props.tempShortList.filter(t => t.isrc === rowInfo.original.isrc).length > 0 ? 'white' : 'black',
                    
                }
            }
        } else {
            return {
                onClick: (e, handleOriginal) => {
                    if (handleOriginal) {
                        handleOriginal()
                    }
                }
            }
        }
    }
    return (
        <ReactTable
            getTrProps={onRowClick}
            data={data}
            filterable
            filtered={main.state.filtered}
            onFilteredChange={(filtered, column, value) => {
                main.onFilteredChangeCustom(value, column.id || column.accessor);
            }}
          
            defaultFilterMethod={(filter, row, column) => {
                const id = filter.pivotId || filter.id;                
                if (typeof filter.value === "object") {                    
                    return row[id] !== undefined || row[id] !==  null
                        ? filter.value.indexOf(row[id]) > -1
                        : true;
                } else {
                    return row[id] !== undefined
                        ? String(row[id]).toLowerCase().indexOf(filter.value.toLowerCase()) !== -1
                        : true;
                }
            }}

              
            columns={getColumns()}
            defaultSorted={[
                {
                    id: "name",
                    desc: true
                }
            ]}
            defaultPageSize={50}
            style={{
                height: "600px" // This will force the table body to overflow and scroll, since there is not enough room
            }}
            className="-striped -highlight"
        />)
};





export default connect(
    state => state.data,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(Release);



// WEBPACK FOOTER //
// ./src/components/Release.js